import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import BasemapEnableMenuItem from "@/v2-backoffice-client/basemap/enable/BasemapEnableMenuItem"
import FeatureRenameMenuItem from "@/v2-backoffice-client/feature/rename/FeatureRenameMenuItem"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

export type BasemapActionMenuProps = {
  basemap: BasemapFragment
  /**
   * Requests the rename dialog. The dialog is owned by the TABLE, not this
   * menu: the row toolbar only exists while its row is hovered or holds an
   * open menu, so anything mounted here dies the moment the menu closes.
   */
  onRename(): void
}

function BasemapActionMenu(props: BasemapActionMenuProps) {
  const { basemap, onRename } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <BasemapEnableMenuItem basemap={basemap} />
        <FeatureRenameMenuItem
          dataFeatureCode="UI_BackofficeBasemaps_Rename_MenuItem"
          onSelect={onRename}
        />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default BasemapActionMenu
